import type { RecaptchaTokenError } from '~/utils/RecaptchaTokenError'
import type { TranslateFn } from './TranslateFn'

type RecaptchaMessageKey =
  'presentation.errors.recaptcha.siteKeyMissing' | 'presentation.errors.recaptcha.unreachable'

const KEY_BY_REASON: Readonly<Record<RecaptchaTokenError['reason'], RecaptchaMessageKey>> = {
  'empty-token': 'presentation.errors.recaptcha.unreachable',
  'execute-failed': 'presentation.errors.recaptcha.unreachable',
  'script-load-failed': 'presentation.errors.recaptcha.unreachable',
  'site-key-missing': 'presentation.errors.recaptcha.siteKeyMissing',
  timeout: 'presentation.errors.recaptcha.unreachable'
}

/** The user-facing message for a reCAPTCHA token that could not be obtained. */
export const recaptchaTokenErrorMessage = (error: RecaptchaTokenError, t: TranslateFn): string =>
  t(KEY_BY_REASON[error.reason])
